const func = $target => {

    console.log('add case product loaded');

	var $modal = $target.find('#mandatoryProducts'),
        $modalBtn = $modal.find('[data-id="product-submit"]');

    $('.case-add-products').each(function() {        
        var $form = $(this),
            $btn = $form.find('button[type="submit"]');

        $btn.on('click', function(e) {          
            e.preventDefault();
            e.stopImmediatePropagation(); 
            
            $('#mandatoryProducts').modal('show');

            $modalBtn.on('click',function(e) {
                e.preventDefault();
                $form.submit();
            });
        });
    });
};

export default func;